import { BaseService } from '@/services/base.service'

export class PerformanceAllowanceService extends BaseService {
  static get entity () {
    return '/mastering/perform-allowance-period'
  }
}

export class PerformanceStatusAllowanceService extends BaseService {
  static get entity () {
    return '/mastering/perform-allowance-period/status'
  }
}

export class PerformanceAllowanceViewService extends BaseService {
  static  get entity () {
    return '/payslip/perform-allowance'
  }
}
